/* =========================================
   FAN BUNDLE BUILDER
   Shopify + GemPages Compatible
========================================= */

/* =========================================
   GLOBAL CONFIG
========================================= */

const bundleRules = {};
const bundleContent = {};

window.BUNDLE_RULES.forEach(rule => {
  bundleRules[rule.qty] = rule;
});

window.BUNDLE_CONTENT.forEach(item => {
  bundleContent[item.qty] = item;
});

/* =========================================
   APP STATE
========================================= */

const app = document.querySelector(
  '#id-fan-bundle-app'
);

let activeBundleQty = 1;

let bundleSelections = {
  1: 'white'
};

/* =========================================
   VARIANT MEDIA SYNC — GemPages gp-product-images-v3
========================================= */

const IMAGES_ROOT = 'gp-product-images-v3[data-id="gwYn4jZXDR"]';

// Shopify media_id per color — read from the <img id="..."> in the DOM
const COLOR_MEDIA = {
  white: '27463759757414',
  black: '27463757758566' 
};

let lastMediaColor = null;

/* =========================================
   HELPERS
========================================= */

function money(cents) {
  const currency =
    window.PRODUCT_DATA.currencyCode || "USD";

  const amount = cents / 100;

  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: currency,
    maximumFractionDigits: 0,
  }).format(Math.floor(amount));
}

/* =========================================
   PRICING ENGINE
========================================= */

function calculateBundlePricing(qty) {

  const basePrice = window.PRODUCT_DATA.basePrice;

  const compareAtPrice = window.PRODUCT_DATA.compareAtPrice;

  const discount = bundleRules[qty]?.discount || 0;

  const discountedUnitPrice = bundleRules[qty]?.discountPrice

  const total = discountedUnitPrice * qty;

  const regularTotal = compareAtPrice * qty;

  const savings = regularTotal - total;

  return {
    qty,
    discount,
    unitPrice: discountedUnitPrice,
    total,
    savings,
    compareAtPrice
  };

}

/* =========================================
   BUNDLE CARD TEMPLATE
========================================= */

function createBundleCard(qty) {

  const pricing =
    calculateBundlePricing(
      parseInt(qty)
    );
    
  const content = bundleContent[qty];

  return `

    <div
      class="
        c-bundle-card
        ${
          parseInt(qty) === activeBundleQty
          ? 'active'
          : ''
        }
      "
      data-qty="${qty}"
    >

      <div class="c-bundle-card-inner">

        <div class="c-bundle-card-header">
            <div class="c-bundle-title">
    
              ${qty} ${qty > 1? 'Fans' : 'Fan'}
    
            </div>
            
            <div class="c-bundle-subtitle">
    
              ${content.subtitle}
    
            </div>
        </div>
        
        <div class="c-bundle-image">

          <img src="${content.image}" alt="${qty} spin360 fan" width="100" height="100" />

        </div>

        <div class="c-bundle-card-footer">
            <div class="c-bundle-price">
    
              ${money(pricing.unitPrice)}
              each
    
            </div>
    
            <div class="c-bundle-total">
    
              ${money(pricing.total)}
              total
    
            </div>
    
            ${
              pricing.compareAtPrice > 0
                ? `
                  <div class="c-bundle-savings">
                    SAVE
                    ${money(pricing.savings)}
                  </div>
                `
                : ''
            }
        </div>

      </div>

    </div>

  `;

}

/* =========================================
   RENDER BUNDLE CARDS
========================================= */

function renderBundleCards() {

  const bundleGrid =
    app.querySelector(
      '#id-bundle-grid'
    );

  let html = `<div class="indicator"></div>`;

  Object.keys(bundleRules)
    .forEach(qty => {

      html += createBundleCard(qty);

    });

  bundleGrid.innerHTML = html;

}

/* =========================================
   SWATCH TEMPLATE
========================================= */

function renderSwatch(color, selectedColor) {
  return `

    <button
      class="
        c-swatch
        ${color}
        ${
          color === selectedColor
          ? 'active'
          : ''
        }
      "
      data-color="${color}"
      type="button"
    >
        <span class="c-swatch-image">
            <img src="${ color == 'white'? 'https://cdn.shopify.com/s/files/1/0579/8930/0326/files/Rectangle_89.jpg?v=1779905480' : 'https://cdn.shopify.com/s/files/1/0579/8930/0326/files/Rectangle_89_1.jpg?v=1779905480'}" width="100" height="100" />
        </span>
        <span class="c-swatch-title">${color == 'white'? 'White Pearl' : 'Black Pearl'}</span>
    </button>

  `;

}

/* =========================================
   CONFIG ITEM TEMPLATE
========================================= */

function renderFanConfigItem(index) {

  const selectedColor =
    bundleSelections[index] || 'white';

  return `

    <div
      class="c-config-item"
      data-index="${index}"
    >

      <div class="c-config-title">

        Choose color for Fan ${index}

      </div>

      <div class="c-swatch-group">
        <div class="swatch-indicator"></div>

        ${renderSwatch(
          'white',
          selectedColor
        )}

        ${renderSwatch(
          'black',
          selectedColor
        )}

      </div>

    </div>

  `;

}

/* =========================================
   RENDER CONFIGURATOR
========================================= */

function renderConfigurator(qty) {

  const configurator =
    app.querySelector(
      '#id-bundle-configurator'
    );

  /*
  =========================================
  ENSURE DEFAULT STATE EXISTS
  =========================================
  */

  for(let i = 1; i <= qty; i++) {

    if(!bundleSelections[i]) {

      bundleSelections[i] = 'white';

    }

  }

  let html = '';

  for(let i = 1; i <= qty; i++) {

    html += renderFanConfigItem(i);

  }

  configurator.innerHTML = html;

  bindSwatchEvents();

}

/* =========================================
   SWATCH EVENTS
========================================= */

function bindSwatchEvents() {

  const configItems =
    app.querySelectorAll('.c-config-item');

  configItems.forEach(item => {

    const index = item.dataset.index;

    const swatches =
      item.querySelectorAll('.c-swatch');

    const indicator =
      item.querySelector('.swatch-indicator');

    function moveIndicator(target) {

      if (!indicator || !target) return;

      const parentRect =
        item.getBoundingClientRect();

      const rect =
        target.getBoundingClientRect();

      indicator.style.width =
        `${rect.width}px`;

      indicator.style.height =
        `${rect.height}px`;

      indicator.style.transform = `
        translateX(${(rect.left - parentRect.left) - 1}px)
      `;
    }

    // initial active state
    const activeSwatch =
      item.querySelector('.c-swatch.active');

    if (activeSwatch) {
      moveIndicator(activeSwatch);
    }

    swatches.forEach(swatch => {

      swatch.addEventListener(
        'click',
        () => {

          swatches.forEach(s =>
            s.classList.remove('active')
          );

          swatch.classList.add('active');

          bundleSelections[index] =
            swatch.dataset.color;

          // move border
          moveIndicator(swatch);

          console.log(swatch.dataset.color);

          syncVariantMedia(swatch.dataset.color); 

        }
      );

    });

  });

}

/* =========================================
   ACTIVE CARD UI
========================================= */

function updateActiveBundleCard(qty) {

  const cards =
    app.querySelectorAll(
      '.c-bundle-card'
    );
    
  const pricing =
    calculateBundlePricing(
      parseInt(qty)
    );
    
    
  const grid = app.querySelector('#id-bundle-grid');
  grid.style.setProperty('--active-index', qty);
  
  const addToCartBtn =  document.querySelector('#id-bundle-add-cart')

  cards.forEach(card => {

    card.classList.remove('active');

    if(
      parseInt(card.dataset.qty)
      === qty
    ) {

      card.classList.add('active');

    }

  });
  
  if(addToCartBtn)
    addToCartBtn.innerText = `Add to Cart - ${money(pricing.total)}`

}

/* =========================================
   ACTIVE BUNDLE HANDLER
========================================= */

function setActiveBundle(qty) {

  activeBundleQty = qty;

  updateActiveBundleCard(qty);

  renderConfigurator(qty);

}

/* =========================================
   CARD EVENTS
========================================= */

function bindBundleCardEvents() {

  const cards =
    app.querySelectorAll(
      '.c-bundle-card'
    );

  cards.forEach(card => {

    card.addEventListener(
      'click',
      () => {

        const qty =
          parseInt(
            card.dataset.qty
          );

        setActiveBundle(qty);

      }
    );

  });

}

/* =========================================
   RESET UI
========================================= */

function resetBundleBuilder() {

  /*
  ==========================
  RESET STATE
  ==========================
  */

  activeBundleQty = 1;

  bundleSelections = {
    1: 'white'
  };

  lastMediaColor = null;

  /*
  ==========================
  RE-RENDER UI
  ==========================
  */

  renderBundleCards();

  bindBundleCardEvents();

  renderConfigurator(1);

  updateActiveBundleCard(1);

  /*
  ==========================
  RESET CTA PRICE
  ==========================
  */

  const button =
    document.querySelector(
      '#id-bundle-add-cart'
    );

  if(button) {

    const pricing =
      calculateBundlePricing(1);

    button.innerText =
      `Add to Cart - ${money(pricing.total)}`;

  }

}

/* =========================================
   AJAX ADD TO CART
========================================= */

async function addBundleToCart() {

  const button =
    document.querySelector(
      '#id-bundle-add-cart'
    );

  if (!button) return;

  const originalText =
    button.innerText;

  button.innerText = '';
  button.disabled = true;

  const itemMap = {};

  Object.entries(bundleSelections)
    .slice(0, activeBundleQty)
    .forEach(([index, color]) => {

      const variantId =
        window.FAN_VARIANTS[color];

      if (itemMap[variantId]) {

        itemMap[variantId].quantity += 1;

      } else {

        itemMap[variantId] = {

          id: variantId,

          quantity: 1

        };

      }

    });

  const items = Object.values(itemMap);

  try {

    await fetch('/cart/add.js', {

      method: 'POST',

      headers: {
        'Content-Type':
          'application/json'
      },

      body: JSON.stringify({

        items

      })

    });

    document.dispatchEvent(new CustomEvent('cart:open'));

    resetBundleBuilder();

    // window.location.href =
    //   '/cart';

  } catch(error) {

    console.error(
      'Bundle add failed',
      error
    );

  } finally {
    button.disabled = false;
    
    const pricing =
      calculateBundlePricing(1);

    button.innerText =
      `Add to Cart - ${money(pricing.total)}`;

    
  }

}

/* =========================================
   VARIANT MEDIA SYNC — GemPages gp-product-images-v3
========================================= */

function getFeatureSwiper() {
  const el = document.querySelector(
    `${IMAGES_ROOT} [id^="gp-carousel-ft-gp-carousel-"]`
  );
  return el?.swiper || null;
}

function slideIndexForMedia(mediaId) {
  const img = document.querySelector(
    `${IMAGES_ROOT} .gp-ft-image-item img[id="${mediaId}"]`
  );
  const slide = img?.closest('.gem-slider-item');
  return slide ? Number(slide.dataset.swiperSlideIndex) : null;
}

function syncVariantMedia(color) {
  if (color === lastMediaColor) return;
  lastMediaColor = color;

  const index = slideIndexForMedia(COLOR_MEDIA[color]);
  if (index == null) return;

  const swiper = getFeatureSwiper();

  if (swiper) {
    if (swiper.params.loop && typeof swiper.slideToLoop === 'function') {
      swiper.slideToLoop(index, 400);
    } else {
      swiper.slideTo(index, 400);
    }
  } else {
    // desktop-only fallback if the Swiper instance isn't exposed
    document.querySelector(
      `${IMAGES_ROOT} .gp-gallery-image-item[data-swiper-slide-index="${index}"]`
    )?.click();
  }

  scrollGalleryIntoView();
}

function scrollGalleryIntoView() {
  if (window.innerWidth > 768) return;   // mobile only

  const root = document.querySelector(IMAGES_ROOT);
  if (!root) return;

  const rect = root.getBoundingClientRect();
  if (rect.top >= 0 && rect.bottom <= window.innerHeight) return;

  root.scrollIntoView({
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'auto' : 'smooth',
    block: 'center'
  });
}

function whenCarouselReady(cb, tries = 40) {
  if (getFeatureSwiper()) return cb();
  if (tries <= 0) return;                       // give up quietly after ~6s
  setTimeout(() => whenCarouselReady(cb, tries - 1), 150);
}

/* =========================================
   CTA EVENTS
========================================= */

function bindAddToCartButton() {

  const button =
    document.querySelector(
      '#id-bundle-add-cart'
    );

  if(!button) return;

  button.addEventListener(
    'click',
    addBundleToCart
  );
  
  const pricing =
    calculateBundlePricing(
      parseInt(activeBundleQty)
    );
  
  button.innerText = `Add to Cart - ${money(pricing.total)}`

}

/* =========================================
   INIT
========================================= */

function initBundleBuilder() {

  if(!app) return;

  renderBundleCards();

  bindBundleCardEvents();

  renderConfigurator(
    activeBundleQty
  );

  bindAddToCartButton();

  whenCarouselReady(() => { lastMediaColor = bundleSelections[1]; });

}

/* =========================================
   DOM READY
========================================= */

document.addEventListener(
  'DOMContentLoaded',
  initBundleBuilder
);